var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"food-box"},[_c('div',{staticClass:"public-box-img",style:({backgroundImage: 'url(' + _vm.coverImgUrl + ')', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat'})}),_c('Djmjseven')],1)}
var staticRenderFns = []

export { render, staticRenderFns }